import React, {ChangeEvent, useState} from 'react';
import {FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, TextField} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";

interface IProps {
    onEnter?: () => void;
    onChange: (changes: { [key: string]: any }) => void;
    inputKey?: string;
    label?: string;
    value: string;
    type?: string;
    sx?: any;

    [key: string]: any;
}

const Input: React.FC<IProps> = (
        {
            onEnter,
            onChange,
            inputKey,
            label,
            value,
            type,
            sx,
            ...rest
        }) => {

    const onChangeHandler = inputKey ? (event: ChangeEvent<HTMLInputElement>) => onChange({[inputKey]: event.currentTarget.value}) : onChange;
    const handleKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            if (onEnter) {
                onEnter();
            }
        }
    }
    const theme = useTheme();
    let sxProps = {...sx};

    const {
        // autoFillBackground = darken(theme.palette.textButton.background, 0.6),
    } = rest;

    delete rest['autoFillBackground']

    if (theme.palette.mode === "dark") {
        sxProps = {
            ...sxProps,
            input: {
                '&:-webkit-autofill': {
                    // WebkitBoxShadow: '0 0 0 100px ' + autoFillBackground + ' inset',
                    WebkitTextFillColor: '#d29cde',
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                },
            }
        }
    }

    if (type === "password") {

        const [showPassword, setShowPassword] = useState(false);

        const handleClickShowPassword = () => {
            setShowPassword(!showPassword);
        };

        const handleMouseDownPassword = (event: React.MouseEvent) => {
            event.preventDefault();
        };
        return <FormControl variant="outlined">
            <InputLabel htmlFor="outlined-adornment-password"> {label} </InputLabel>
            <OutlinedInput
                    id="outlined-adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    value={value}
                    onChange={onChangeHandler}
                    sx={{
                        marginBottom: "20px",
                        ...sxProps
                    }}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end">
                                {showPassword ? <VisibilityOff/> : <Visibility/>}
                            </IconButton>
                        </InputAdornment>
                    }
                    label={label}
            />
        </FormControl>
    }

    return <TextField
            label={label}
            type="email"
            autoComplete="current-email"
            onChange={onChangeHandler}
            onKeyPress={handleKeyPress}
            value={value}
            sx={{
                marginBottom: "20px",
                ...sxProps
            }}
            {...rest}
    />
};

export default Input;
